export function stock(stock) {
  if (typeof stock === "undefined")
    return "0";

  if (stock === "")
    stock = "0";

  return "(" + stock + ")";
}
